var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var PostController = /** @class */ (function () {
    function PostController() {
    }
    /*****************************************************************************************************
        * Is using route "api/post/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{groupid}/{fromdate}/{todate}/{onlyvisible}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @param {string} fromdate
        * @param {string} todate
        * @param {PostVisibleState} onlyvisible
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.GetFromTo = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{groupid}/{fromdate}/{todate}/{onlyvisible}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/filtered" and http method "POST" to call the back-end.
    Returns posts that are filtered with a given filter.
    
        * @param {PostFilterDto} filter  filters the posts by several properties
        * @returns {PostDownloadDto[]}
    ******************************************************************************************************/
    PostController.GetFiltered = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/filtered", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/count/filtered" and http method "POST" to call the back-end.
    Counts filtered posts
    
        * @param {PostFilterDto} filter  filters the posts by several properties
        * @returns {number}
    ******************************************************************************************************/
    PostController.CountFiltered = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/count/filtered", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{groupid}/{type}/{onlyvisible?}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @param {string} type
        * @param {PostVisibleState} onlyvisible
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.GetByType = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{groupid}/{type}/{onlyvisible?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/token/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.GetPaged = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/token/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/allgroups/sortby/{by}/{additionalData}" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {FetchPostsFilter} filter
        * @param {string} by
        * @param {string} additionalData
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.GetPagedForAllGroupsSortedBy = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/allgroups/sortby/{by}/{additionalData}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/allgroups/trending" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.GetPagedForAllGroupsTrending = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/allgroups/trending", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/allgroups" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.GetPagedForAllGroups = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/allgroups", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/inherit/{force?}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {boolean} force
        * @returns {void}
    ******************************************************************************************************/
    PostController.InheritPost = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/inherit/{force?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/hide/{id}/{hidden}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {boolean} hidden
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostController.SetPostHidden = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/hide/{id}/{hidden}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/token/{groupid}/{type}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {string} type
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.GetTypedPaged = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/token/{groupid}/{type}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/type" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {string}
    ******************************************************************************************************/
    PostController.GetElementType = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/type", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/single" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostController.GetSinglePost = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/single", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{userid}/user" and http method "GET" to call the back-end.
    
        * @param {string} userid
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.GetForUser = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{userid}/user", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{userid}/user" and http method "POST" to call the back-end.
    Returns all posts for a given user as a paged result
    
        * @param {string} userid  the user
        * @param {TokenContainer} token  input continuation token for paged result
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.GetForUserPaged = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{userid}/user", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.token
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{postid}" and http method "DELETE" to call the back-end.
    
        * @param {string} postid
        * @returns {void}
    ******************************************************************************************************/
    PostController.DeletePost = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{postid}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/export_dto_to_swagger" and http method "GET" to call the back-end.
    
        * @returns {MediaUploadDto}
    ******************************************************************************************************/
    PostController.ExportDto = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/export_dto_to_swagger", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{groupid}/tags" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {TagDownloadDto[]}
    ******************************************************************************************************/
    PostController.GetTags = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{groupid}/tags", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{postid}/copy/{groupid}/{typeName}" and http method "POST" to call the back-end.
    
        * @param {string} postid
        * @param {string} groupid
        * @param {string} typeName
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostController.CopyPost = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{postid}/copy/{groupid}/{typeName}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{postid}/promote" and http method "POST" to call the back-end.
    
        * @param {string} postid
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostController.PromotePost = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{postid}/promote", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{postid}/demote" and http method "POST" to call the back-end.
    
        * @param {string} postid
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostController.DemotePost = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{postid}/demote", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/getRouteInfo/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {RouteInfoDto}
    ******************************************************************************************************/
    PostController.GetRouteInfo = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/getRouteInfo/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/lock/{id}/{connectionId}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} connectionId
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostController.PostLock = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/lock/{id}/{connectionId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/unlock/{id}/{connectionId}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} connectionId
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostController.PostUnlock = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/unlock/{id}/{connectionId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/unlockall/{connectionId}" and http method "POST" to call the back-end.
    
        * @param {string} connectionId
        * @returns {PostDownloadDto[]}
    ******************************************************************************************************/
    PostController.PostUnlockAll = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/unlockall/{connectionId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/{id}/children" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ExtendedDataCollection<PostChildren, PostDownloadDto>}
    ******************************************************************************************************/
    PostController.GetPostChildren = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/{id}/children", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/search" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {string} type
        * @param {string} lng
        * @param {string[]} groupIds
        * @returns {PostDownloadDto[]}
    ******************************************************************************************************/
    PostController.SearchPostText = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        if (data.type !== undefined)
            fd.append("type", JSON.stringify(data.type));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.groupIds !== undefined)
            fd.append("groupIds", JSON.stringify(data.groupIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/suggest" and http method "POST" to call the back-end.
    
        * @param {string} term
        * @param {string} type
        * @param {string} lng
        * @param {string[]} groupIds
        * @returns {string[]}
    ******************************************************************************************************/
    PostController.SuggestPostTerm = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("term", JSON.stringify(data.term));
        if (data.type !== undefined)
            fd.append("type", JSON.stringify(data.type));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.groupIds !== undefined)
            fd.append("groupIds", JSON.stringify(data.groupIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/suggest", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/search1" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.SearchPostText1 = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search1", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/search2" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.SearchPostText2 = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search2", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/search/systems" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {SearchSystems} systems
        * @param {string} progressId
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<PostDownloadDto, string>}
    ******************************************************************************************************/
    PostController.SearchSystemsPostText = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        fd.append("systems", JSON.stringify(data.systems));
        fd.append("progressId", JSON.stringify(data.progressId));
        fd.append("lng", JSON.stringify(data.lng));
        fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search/systems", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/post/search/systems/post/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ExtendedDataCollection<ItemSearchResult<PostDownloadDto>, string>}
    ******************************************************************************************************/
    PostController.GetPostSystemsSearchResults = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search/systems/post/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/post/search/systems/wiki/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ExtendedDataCollection<WikiSearchResultDto, string>}
    ******************************************************************************************************/
    PostController.GetWikiSystemsSearchResults = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/search/systems/wiki/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/Suggest2" and http method "POST" to call the back-end.
    
        * @param {string} term
        * @param {string} type
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {string[]}
    ******************************************************************************************************/
    PostController.SuggestPostTerm2 = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("term", JSON.stringify(data.term));
        if (data.type !== undefined)
            fd.append("type", JSON.stringify(data.type));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/Suggest2", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/Suggest1" and http method "POST" to call the back-end.
    
        * @param {string} term
        * @param {string} type
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {string[]}
    ******************************************************************************************************/
    PostController.SuggestPostTerm1 = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("term", JSON.stringify(data.term));
        if (data.type !== undefined)
            fd.append("type", JSON.stringify(data.type));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/Suggest1", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/suggest/system" and http method "POST" to call the back-end.
    
        * @param {string} term
        * @param {SearchSystems} systems
        * @param {string} type
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {string[]}
    ******************************************************************************************************/
    PostController.SuggestSystemTerm = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("term", JSON.stringify(data.term));
        fd.append("systems", JSON.stringify(data.systems));
        if (data.type !== undefined)
            fd.append("type", JSON.stringify(data.type));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/suggest/system", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/link" and http method "POST" to call the back-end.
    
        * @param {LinkDefinitionUploadDto} linkDefinition
        * @returns {LinkDefinitionDownloadDto}
    ******************************************************************************************************/
    PostController.CreateAccessLink = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("linkDefinition", JSON.stringify(data.linkDefinition));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/link", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/link/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {LinkDefinitionDownloadDto[]}
    ******************************************************************************************************/
    PostController.GetAccessLink = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/link/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/link/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    PostController.DeleteAccessLink = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/link/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/post/link/public/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostController.AccessPublicLink = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/link/public/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/link/private/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {PostDownloadDto}
    ******************************************************************************************************/
    PostController.AccessPrivateLink = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/link/private/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return PostController;
}());
export { PostController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PostController.js.map